import React from "react";

const Map = (props) => {
  const divStyle = {
    backgroundImage: "url(" + props.image + ")",
    width: "100%",
    height: "320px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "50%",
  };

  return (
    <>
      <img style={divStyle} alt="" />
    </>
  );
};

export default Map;
